module.exports = {
    zh: {
        add: '新增',
        addProject: '新增项目',
        update: '修改',
        delete:'删除',
        garden:"园所",
        edit:'编辑',
        number: '序号',
        bankCardNumber:'退款账户',
        studentEnglishName:'学生英文名字',
        payService:"收费项目",
        name:'收费项目名称',
        alipayTransactionNumber:'支付宝交易号',
        chargeBillName: '收费账单名称',
        defaultProject:'默认项目',
        instruction:'项目说明',
        groupControl:'集团管控',
        takeEffect:'生效',
        chargeClassification:'收费分类',
        price:'单价',
        operation:"操作",
        search: '搜索',
        reset: '重置',
        class:'班级',
        studentName:'学生姓名',
        chargeMode:'收费方式',
        payDate:'收费日期',
        refundDate:'退费日期',
        paymentTime:'缴费时间',
        remark:'备注',
        billNumber:'收费账单编号',
        chargingRecordNumber: '收费记录编号',
        chargingTime: '收费发生时间',
        timeOfRefund:'退费发生时间',
        headquartersCharges:'园所收费项目',
        studentPrivilegeManagement:'学生优惠管理',
        preferentialAmount:'优惠金额',
        generateDate: '生成日期',
        billName: '账单名称',
        paymentStatus:' 支付状态',
        source: '来源',
        sendStatus: '发送状态',
        addBill: '新增账单',
        bulkBilling: '批量发送账单',
        rushPayCost: '一键催缴',
        batchPrintData: '批量打印收据',
        bulkExportData: '批量导出数据',
        deleteBill: '删除账单',
        exportChargeBill: '导出收费账单',
        confirmCharge: '确认收费',
        confirmRefund:'确认退费',
        refundGenerateDate: '退费生成日期',
        refundBillNumber: '退费账单编号',
        detailsOfRefundBills:'退费账单详情',
        collectionBillNumber: '收款账单编号',
        numberOfCarryOverBill:'结转账单编号',
        auditStatus: '审核状态',
        refundStatus: '退费状态',
        auditNotes:'审核备注',
        refundNote:'退费备注',
        refundAccount:'退费账户',
        refundItem:'退费项目',
        refundMethod:'退费方式',
        returnableAmount:'可退金额',
        amountToBeRefunded:'应退金额',
        initiateRefund: '发起退费',
        validDateOfCharge:'收费有效日期',
        batchAuditPass: '批量审核通过',
        batchAudit: '批量审核',
        exportRefundBill: '导出退费账单',
        audit: '审核',
        export: '导出',
        exportChargeRecord:'导出收费记录',
        chargeBillNumber: '收费账单编号',
        money: '金额',
        billingDate: '账单生成日期',
        close: '关闭',
        studentNumber: '学生编号',
        lastPayDate:'缴费截止日期',
        billDetails: '账单详情',
        chargeProject: '收费项目',
        chargeRecord: '收费记录',
        refundRecord:'退费记录',
        refundRecordNumber:'退费记录编号',
        count: '数量',
        discountedAmount: '实际金额',
        chargeEffectDate: '收费生效日期',
        chargeExpireDate:'收费到期日期',
        projectIntroduction: '项目说明',
        payStyle: '收费方式',
        chargeAmount: '收费金额',
        note: "备注",
        total: '总计',
        totalRefundAmount:'总退金额',
        received: '已收',
        waitCollect:' 待收',
        discountTotal: '折后总计',
        actualCollect: '本次实收',
        chargeHappenDate: '收费发生时间',
        exit: '退出',
        save: '保存',
        chargeBillUpdate: '收费账单修改',
        remove: '移除',
        chooseStudent: '选择学生',
        gender: '性别',
        historyBillQuery: '历史账单查询',
        addChargeItem: '添加收费项目',
        payState: '支付状态',
        batchIntroduceStayRefundSettlement: '批量引入待退费结算',
        referenceRefund: '自动引用待退费结算',        
        cancel: '取消',
        query: '查询',
        paymentHistory: '缴费历史',
        schoolStudent: '在校学生',
        visitStudent: '看园学生',
        babyName: '宝宝姓名',
        babyBirthday: '宝宝生日',
        signUpPeople: '报名人',
        status: '状态',
        phoneNumber: '手机号',
        autoDeduction: '自动抵扣诚意金',
        serialNumber: '编号',
        refundProject: '退费项目',
        refundAmount: '退款金额',
        actualRefundAmount:'本次实退金额',
        rushRed: '冲红',
        rushRedAmount: '冲红金额',
        statisticalAmount: '统计金额',
        totalAmount: '总金额',
        repeatRemind: '重复收费提醒',
        repeatProject: '重复项目',
        effectiveDate: '有效期',
        continue: '继续',
        billNum: '账单编号',
        determine: '确定'
    },
    en: {
        add: 'add',
        addProject: 'New project',
        update: 'update',
        delete:'delete',
        garden:"garden",
        edit:'edit',
        number:' number',
        bankCardNumber:'Refund account',
        studentEnglishName:'Student English Name',
        payService:"Pay Service",
        name:'Name of fee item',
        alipayTransactionNumber:'Alipay transaction number',
        defaultProject:'Default project',
        instruction:'Project description',
        groupControl:'group control',
        takeEffect:'Take effect',
        chargeClassification:'Charge classification',
        price:'price',
        operation:"operation",
        search: 'search',
        reset: 'reset',
        class:'class',
        studentName:'studentName',
        chargeMode:'Charge mode',
        payDate:'Date of charge',
        refundDate:'Refund date',
        paymentTime:'Payment time',
        remark:'remark',
        billNumber:'Toll account number',
        chargingRecordNumber:'Charging record number',
        chargingTime: 'Charging time',
        timeOfRefund:'Time of refund',
        headquartersCharges:'Headquarters charges',
        studentPrivilegeManagement:'Student privilege management',
        preferentialAmount:'Preferential amount',
        generateDate: 'generate the date',
        chargeBillName: 'Name of the bill',
        billName: 'bill name',
        paymentStatus: 'Payment status',
        source: 'source',
        sendStatus: 'send status',
        addBill: 'The new bill',
        bulkBilling: 'Bulk billing',
        rushPayCost: 'rush Pay cost',
        batchPrintData: 'batch Print data',
        bulkExportData: 'Bulk export data',
        deleteBill: 'Delete the billing',
        exportChargeBill: 'Export bill',
        confirmCharge: 'Confirm the charge',
        confirmRefund:'Confirm refund',
        refundGenerateDate: 'Refund date',
        refundBillNumber: 'Refund bill number',
        detailsOfRefundBills:'Details of refund bills',
        collectionBillNumber: 'collection Bill Number',
        numberOfCarryOverBill:'Number of carry over bill',
        auditStatus: 'Review the status',
        refundStatus: 'Refund status',
        auditNotes:'Audit notes',
        refundNote:'Refund note',
        refundAccount:'Refund account',
        refundItem:'Refund item',
        refundMethod:'Refund method',
        returnableAmount:'Returnable amount',
        amountToBeRefunded:'Amount to be refunded',
        initiateRefund: 'Initiate a refund',
        validDateOfCharge:'Valid date of charge',
        batchAuditPass: 'batch Audit Pass',
        batchAudit: 'batch Audit',
        exportRefundBill: 'Export the refund bill',
        audit: 'audit',
        export: 'export',
        exportChargeRecord:'Export charge record',
        chargeBillNumber: 'Billing number',
        money: 'Amount of money',
        billingDate: 'Billing date',
        close: 'close',
        studentNumber: 'student number',
        lastPayDate: 'Deadline for payment',
        billDetails: 'The billing details',
        chargeProject: 'Charging projects',
        chargeRecord: 'charge record',
        refundRecord:'Refund record',
        refundRecordNumber:'Refund record number',
        count: 'The number of',
        discountedAmount: 'Discounted amount',
        chargeEffectDate: 'Charge Effective date',
        chargeExpireDate: 'Expiry date of charge',
        projectIntroduction:'Project introduction',
        payStyle: 'Way to charge',
        chargeAmount: 'charge Amount',
        note: "note",
        total: 'total',
        totalRefundAmount:'Total refund amount',
        received: 'received',
        waitCollect: 'collection',
        discountTotal: 'Total after discount',
        actualCollect: 'actual collect',
        chargeHappenDate: 'charge happen date',
        exit: 'exit',
        save: 'save',
        chargeBillUpdate: 'Modify the bill',
        remove: 'remove',
        chooseStudent: 'Select the student',
        gender: 'gender',
        historyBillQuery: 'Historical bill query',
        addChargeItem: 'Add charging items',
        payState: 'pay state',
        batchIntroduceStayRefundSettlement: 'Batch introduction Pending refund Settlement',
        referenceRefund: 'Automated reference to pending refund settlement',
        cancel: 'cancel',
        query: 'query',
        paymentHistory: 'Payment history',
        schoolStudent: 'In the school student',
        visitStudent: 'At the student',
        babyName: 'baby name',
        babyBirthday: 'baby birthday',
        signUpPeople: 'Sign up people',
        status: 'status',
        phoneNumber: 'Mobile phone number',
        autoDeduction: 'Automatic deduction of sincerity payment',
        serialNumber: 'Serial number',
        refundProject: 'Refund project',
        refundAmount: 'The refund amount',
        actualRefundAmount:'Amount of refund',
        rushRed: 'Rush red',
        rushRedAmount: 'Rush red amount',
        statisticalAmount: 'Statistical amount',
        totalAmount: 'The total amount',
        repeatRemind: 'Reminder of double charge',
        repeatProject: 'Repeat project',
        effectiveDate: 'The period of validity',
        continue: 'continue',
        billNum: 'Bill number',
        determine: 'determine'
    }
  }
  



// WEBPACK FOOTER //
// ./src/components/i18n/lang/paymentManagement.js